module.exports = __webpack_public_path__ + "static/media/smallWh.cfeb03da.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/smallWh.png
// module id = 431
// module chunks = 0 1